"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentCommunicator = void 0;

var superagent_1 = __importDefault(require("superagent"));

var Interfaces_1 = require("../Interfaces");

var interface_adapter_1 = require("../Interfaces/interface.adapter");

var Configs_1 = require("../Configs");

var Errors_1 = require("../Errors");

var __1 = require(".."); // eslint-disable-next-line @typescript-eslint/no-var-requires


var clientSDKVersion = require('../../../../package.json').version;

var PaymentCommunicator =
/** @class */
function () {
  function PaymentCommunicator(session) {
    this.env = session.env;
    this.sessionId = session.sessionId;
    this.httpAgent = superagent_1["default"];
    this.appName = session.appName || '~';
    this.channel = session.channel;
  }

  PaymentCommunicator.prototype.getVendorSessionInfo = function () {
    var _a, _b, _c;

    return __awaiter(this, void 0, void 0, function () {
      var fakeSessionInfo, sessionUrl, httpResponse, responseBody, e_1, errorSummary, errorDetails;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (this.env === Interfaces_1.Env.dummy) {
              fakeSessionInfo = {
                sessionId: this.sessionId,
                vendorName: interface_adapter_1.PaymentVendors.dummy,
                vendorSessionPayload: '',
                billingToken: 'dummy-payment-tokenid',
                timestamp: new Date().toISOString()
              };
              return [2
              /*return*/
              , fakeSessionInfo];
            }

            _d.label = 1;

          case 1:
            _d.trys.push([1, 3,, 4]);

            sessionUrl = new URL(Configs_1.Config.getBasePaymentUrl(this.env) + "/applications/".concat(this.appName, "/sessions/").concat(this.sessionId));
            return [4
            /*yield*/
            , this.httpAgent.get(sessionUrl.toString()).timeout(Configs_1.Config.defaultTimeout).set('Content-Type', 'application/json').set('client-sdk-version', clientSDKVersion).set('timestamp', new Date().toISOString())];

          case 2:
            httpResponse = _d.sent();
            responseBody = httpResponse.body;

            if (responseBody.status === 'COMPLETED') {
              throw new Errors_1.PaymentClientError('Session Completed, billing token already created', Interfaces_1.PaymentErrorShortCodes.session_already_completed);
            } else if (responseBody.status === 'TOO_MANY_ATTEMPTS') {
              throw new Errors_1.PaymentClientError('Error tokenizing, too many attempts', Interfaces_1.PaymentErrorShortCodes.tokenization_attempts_exceeded);
            }

            return [2
            /*return*/
            , responseBody];

          case 3:
            e_1 = _d.sent();
            errorSummary = JSON.stringify(e_1);

            if ((_a = e_1.response) === null || _a === void 0 ? void 0 : _a.req) {
              errorSummary = JSON.stringify(e_1, function replacer(key, value) {
                // Delete request details so that the error can be safely logged
                if (key == 'req') return undefined;else return value;
              });
            }

            errorDetails = ((_c = (_b = e_1.response) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.message) || e_1.message;

            if (errorDetails === 'Session Completed, billing token already created') {
              throw new Errors_1.PaymentClientError('Session Completed, billing token already created', Interfaces_1.PaymentErrorShortCodes.session_already_completed);
            }

            if (errorDetails === 'Error tokenizing, too many attempts') {
              throw new Errors_1.PaymentClientError('Error tokenizing, too many attempts', Interfaces_1.PaymentErrorShortCodes.tokenization_attempts_exceeded);
            }

            throw new Errors_1.PaymentClientError('Error getting session data: ' + errorDetails, Interfaces_1.PaymentErrorShortCodes.server_session_error, {
              cause: {
                message: e_1.message,
                details: errorSummary
              }
            });

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentCommunicator.prototype.processPayment = function (encryptedData, paymentMethod, billingContact) {
    var _a, _b, _c, _d, _e;

    return __awaiter(this, void 0, void 0, function () {
      var source, paymentUrl, httpResponse, responseBody, e_2, errorSummary, errorDetails;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            if (this.env === Interfaces_1.Env.dummy) {
              return [2
              /*return*/
              , {
                billingToken: 'fakeDummyPaymentTokenId'
              }];
            }

            _f.label = 1;

          case 1:
            _f.trys.push([1, 4,, 5]);

            return [4
            /*yield*/
            , this.getBrowserDetails()];

          case 2:
            source = _f.sent();
            paymentUrl = new URL(Configs_1.Config.getBasePaymentUrl(this.env) + "/applications/".concat(this.appName, "/sessions/").concat(this.sessionId, "/tokens"));
            return [4
            /*yield*/
            , this.httpAgent.post(paymentUrl.toString()).timeout(Configs_1.Config.defaultTimeout).set('Content-Type', 'application/json').set('client-sdk-version', clientSDKVersion).send({
              clientSDKVersion: clientSDKVersion,
              paymentData: {
                encryptedCustomerInput: encryptedData,
                billingContact: billingContact,
                paymentType: paymentMethod
              },
              source: source
            })];

          case 3:
            httpResponse = _f.sent();
            responseBody = httpResponse.body;
            return [2
            /*return*/
            , responseBody];

          case 4:
            e_2 = _f.sent();
            errorSummary = JSON.stringify(e_2);

            if ((_a = e_2.response) === null || _a === void 0 ? void 0 : _a.req) {
              errorSummary = JSON.stringify(e_2, function replacer(key, value) {
                // Delete request details so that the error can be safely logged
                if (key == 'req') return undefined;else return value;
              });
            }

            if (e_2.timeout) {
              throw new __1.PaymentTimeoutError('Error processing payment: Time-out', Interfaces_1.PaymentErrorShortCodes.payment_timeout, {
                cause: {
                  message: e_2.message,
                  details: errorSummary
                }
              });
            }

            errorDetails = ((_c = (_b = e_2.response) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.message) || e_2.message;
            throw new Errors_1.PaymentClientError('Error processing payment: ' + errorDetails, Interfaces_1.PaymentErrorShortCodes.server_tokenization_error, {
              cause: {
                message: e_2.message,
                vendor: (_e = (_d = e_2.response) === null || _d === void 0 ? void 0 : _d.body) === null || _e === void 0 ? void 0 : _e.vendor,
                details: errorSummary
              }
            });

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentCommunicator.prototype.completePaymentSession = function (authId, isDefaultPaymentMethod) {
    var _a, _b, _c, _d, _e;

    return __awaiter(this, void 0, void 0, function () {
      var source, paymentUrl, httpResponse, responseBody, e_3, errorSummary, errorDetails;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            if (this.env === Interfaces_1.Env.dummy) {
              return [2
              /*return*/
              , {
                paymentId: 'fakePaymentId'
              }];
            }

            _f.label = 1;

          case 1:
            _f.trys.push([1, 4,, 5]);

            return [4
            /*yield*/
            , this.getBrowserDetails()];

          case 2:
            source = _f.sent();
            paymentUrl = new URL(Configs_1.Config.getBasePaymentUrl(this.env) + "/applications/".concat(this.appName, "/sessions/").concat(this.sessionId, "/complete"));
            return [4
            /*yield*/
            , this.httpAgent.post(paymentUrl.toString()).timeout(Configs_1.Config.defaultTimeout).set('Content-Type', 'application/json').set('client-sdk-version', clientSDKVersion).send({
              clientSDKVersion: clientSDKVersion,
              source: source,
              authId: authId,
              isDefaultPaymentMethod: isDefaultPaymentMethod
            })];

          case 3:
            httpResponse = _f.sent();
            responseBody = httpResponse.body;
            return [2
            /*return*/
            , responseBody];

          case 4:
            e_3 = _f.sent();
            errorSummary = JSON.stringify(e_3);

            if ((_a = e_3.response) === null || _a === void 0 ? void 0 : _a.req) {
              errorSummary = JSON.stringify(e_3, function replacer(key, value) {
                // Delete request details so that the error can be safely logged
                if (key == 'req') return undefined;else return value;
              });
            }

            if (e_3.timeout) {
              throw new __1.PaymentTimeoutError('Error processing payment: Time-out', Interfaces_1.PaymentErrorShortCodes.payment_timeout, {
                cause: {
                  message: e_3.message,
                  details: errorSummary
                }
              });
            }

            errorDetails = ((_c = (_b = e_3.response) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.message) || e_3.message;
            throw new Errors_1.PaymentClientError('Error processing payment: ' + errorDetails, Interfaces_1.PaymentErrorShortCodes.server_tokenization_error, {
              cause: {
                message: e_3.message,
                vendor: (_e = (_d = e_3.response) === null || _d === void 0 ? void 0 : _d.body) === null || _e === void 0 ? void 0 : _e.vendor,
                details: errorSummary
              }
            });

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentCommunicator.prototype.initiateWebDropInOrComponentChargeEvent = function (paymentMethod, // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  encryptedData) {
    var _a, _b;

    return __awaiter(this, void 0, void 0, function () {
      var source, sessionUrl, httpResponse, responseBody, e_4, errorDetails;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (this.env === Interfaces_1.Env.dummy) {
              return [2
              /*return*/
              , {
                billingToken: 'fakeDummyPaymentTokenId'
              }];
            }

            _c.label = 1;

          case 1:
            _c.trys.push([1, 4,, 5]);

            return [4
            /*yield*/
            , this.getBrowserDetails()];

          case 2:
            source = _c.sent();
            sessionUrl = new URL(Configs_1.Config.getBasePaymentUrl(this.env) + "/applications/".concat(this.appName, "/sessions/").concat(this.sessionId, "/tokens/intent"));
            return [4
            /*yield*/
            , this.httpAgent.post(sessionUrl.toString()).timeout(Configs_1.Config.defaultTimeout).set('Content-Type', 'application/json').set('client-sdk-version', clientSDKVersion).send({
              clientSDKVersion: clientSDKVersion,
              paymentData: {
                paymentType: paymentMethod,
                encryptedCustomerInput: encryptedData
              },
              source: source
            })];

          case 3:
            httpResponse = _c.sent();
            responseBody = httpResponse.body;

            if (responseBody.message === 'Tokenization Attempts Exceeded') {
              throw new Errors_1.PaymentClientError('Error tokenizing, too many attempts', Interfaces_1.PaymentErrorShortCodes.tokenization_attempts_exceeded);
            }

            return [2
            /*return*/
            , responseBody];

          case 4:
            e_4 = _c.sent();
            errorDetails = ((_b = (_a = e_4.response) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.message) || e_4.message;

            if (errorDetails === 'Error tokenizing, too many attempts') {
              throw new Errors_1.PaymentClientError('Error tokenizing, too many attempts', Interfaces_1.PaymentErrorShortCodes.tokenization_attempts_exceeded);
            }

            throw new Errors_1.PaymentClientError('Error processing payment: ' + errorDetails, Interfaces_1.PaymentErrorShortCodes.server_tokenization_error, {
              cause: JSON.stringify(e_4)
            });

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentCommunicator.prototype.processWebDropInOrComponentChargeEvent = function (paymentMethod, // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  vendorPayload) {
    var _a, _b;

    return __awaiter(this, void 0, void 0, function () {
      var source, sessionUrl, httpResponse, responseBody, e_5, errorDetails;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (this.env === Interfaces_1.Env.dummy) {
              return [2
              /*return*/
              , {
                billingToken: 'fakeDummyPaymentTokenId'
              }];
            }

            _c.label = 1;

          case 1:
            _c.trys.push([1, 4,, 5]);

            return [4
            /*yield*/
            , this.getBrowserDetails()];

          case 2:
            source = _c.sent();
            sessionUrl = new URL(Configs_1.Config.getBasePaymentUrl(this.env) + "/applications/".concat(this.appName, "/sessions/").concat(this.sessionId, "/tokens/result"));
            return [4
            /*yield*/
            , this.httpAgent.post(sessionUrl.toString()).timeout(Configs_1.Config.defaultTimeout).set('Content-Type', 'application/json').set('client-sdk-version', clientSDKVersion).send({
              clientSDKVersion: clientSDKVersion,
              paymentData: {
                paymentType: paymentMethod,
                webComponentStep: 2,
                payload: vendorPayload
              },
              source: source
            })];

          case 3:
            httpResponse = _c.sent();
            responseBody = httpResponse.body;
            return [2
            /*return*/
            , responseBody];

          case 4:
            e_5 = _c.sent();
            errorDetails = ((_b = (_a = e_5.response) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.message) || e_5.message;
            throw new Errors_1.PaymentClientError('Error processing payment: ' + errorDetails, Interfaces_1.PaymentErrorShortCodes.server_tokenization_error, {
              cause: JSON.stringify(e_5)
            });

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentCommunicator.prototype.getBrowserDetails = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , {
          host: window.location.host,
          location: window.location,
          browser: {
            codeName: navigator.appCodeName,
            name: navigator.appName,
            version: navigator.appVersion
          },
          userAgent: navigator.userAgent,
          platform: navigator.platform,
          language: navigator.language,
          languages: navigator.languages,
          referrer: document.referrer || 'N/A',
          online: navigator.onLine,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          timestamp: new Date().toISOString(),
          cookiesEnabled: navigator.cookieEnabled,
          clientSDKVersion: clientSDKVersion,
          channel: this.channel
        }];
      });
    });
  };

  PaymentCommunicator.prototype.logErrorDetails = function (error, paymentClient, billingToken) {
    return __awaiter(this, void 0, void 0, function () {
      var source, sessionId, errorLogUrl;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.env === Interfaces_1.Env.dummy) {
              return [2
              /*return*/
              ];
            } // Silence logs when testing


            if (Configs_1.Config.isProdEnv(this.env) && typeof isTestPaymentBrowser === 'boolean' && isTestPaymentBrowser) {
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , this.getBrowserDetails()];

          case 1:
            source = _a.sent();
            sessionId = 'unknownSessionId';

            if (this.sessionId && this.sessionId.length > 0) {
              sessionId = this.sessionId;
            }

            errorLogUrl = new URL(Configs_1.Config.getBasePaymentUrl(this.env) + "/applications/".concat(this.appName, "/sessions/").concat(sessionId, "/errors"));
            return [4
            /*yield*/
            , this.httpAgent.post(errorLogUrl.toString()).timeout(Configs_1.Config.defaultTimeout).set('Content-Type', 'application/json').set('client-sdk-version', clientSDKVersion).send({
              clientSDKVersion: clientSDKVersion,
              error: {
                message: error.message,
                details: error
              },
              sessionId: sessionId,
              billingToken: billingToken,
              paymentClient: paymentClient,
              source: source
            })];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return PaymentCommunicator;
}();

exports.PaymentCommunicator = PaymentCommunicator;